import React, { Component } from 'react';
import styled from 'styled-components';
import mediaWidth from '../../../utils/mediaWidth/mediaWidth';

import MenuMobile from './MenuMobile';
import MenuDesktop from './MenuDesktop';

import screenData from '../../PhaserComponent/data/screenData';
import getScreenSize from '../../PhaserComponent/getSreenSize';

class Menu extends Component {
    render() {
        const {
            className,
            onClick,
            handleChangePage,
            scrollToForm,
        } = this.props;

        return (
            <Root className={className}>
                <MenuMobileStyled
                    onClick={onClick}
                    scrollToForm={scrollToForm}
                />
                <MenuDesktopStyled onClick={onClick} handleChangePage={handleChangePage} />
            </Root>
        );
    }
}

const Root = styled.div`
    position: fixed;
    top: 16px;
    left: ${() => 2 * ((window.innerWidth - screenData[getScreenSize()].width) / 2) + 291}px;
    /* right: 24px; */

    ${mediaWidth.m} {
        top: 32px;
        left: ${() => 2 * ((window.innerWidth - screenData[getScreenSize()].width) / 2) + 675}px;
        /* right: 48px; */
    };

    ${mediaWidth.l} {
        left: ${() => 2 * ((window.innerWidth - screenData[getScreenSize()].width) / 2) + 754}px;
        /* right: 169px; */
    };

    ${mediaWidth.xl} {
        left: ${() => 2 * ((window.innerWidth - screenData[getScreenSize()].width) / 2) + 1135}px;
        /* right: 197px; */
    };
`;

const MenuMobileStyled = styled(MenuMobile)`
    ${mediaWidth.l} {
        display: none;
    }
`;

const MenuDesktopStyled = styled(MenuDesktop)`
    display: none;

    ${mediaWidth.l} {
        display: flex;
    }
`;

export default Menu;
